import { Button } from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useStyles } from '../styles/BackButtonStyles.styles';

interface BackButtonProps {
    text: string;
    onClick: () => void;
}

export const BackButton = ({ text, onClick }: BackButtonProps) => {
    const styles = useStyles();

    return (
        <Button
            className={styles.backButton}
            variant={'text'}
            onClick={onClick}
        >
            <KeyboardBackspaceIcon className={styles.icon} /> {text}
        </Button>
    );
};
